import React from "react";
import "./Modal.css";

// styles
import useStyles from "../login/styles";

// components
import { CircularProgress } from "@material-ui/core";

const ModalLoading = ({ isOpen, closeModal }) => {
    var classes = useStyles();
    const handleContainerClick = (e) => e.stopPropagation();

    return <article className={`modal-loading ${isOpen && "is-open"}`}
        onClick={closeModal}>
        <div className="modal-container" onClick={handleContainerClick}>
            <div style={{ textAlign: 'center', marginTop: '30px' }}>
                <CircularProgress size={100} color= "#FFFFFF" />
            </div>
        </div>
    </article>
}

export default ModalLoading;